import { render, staticRenderFns } from "./MemberDocModal.vue?vue&type=template&id=1b4abef0&scoped=true"
import script from "./MemberDocModal.vue?vue&type=script&lang=js"
export * from "./MemberDocModal.vue?vue&type=script&lang=js"
import style0 from "./MemberDocModal.vue?vue&type=style&index=0&id=1b4abef0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4abef0",
  null
  
)

export default component.exports